import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { OverlayModule } from '@angular/cdk/overlay';
import moment, { Moment } from 'moment-timezone';

import { DateRangeCalendarComponent } from './date-range-calendar/date-range-calendar.component';
import { OVERLAY_POSITIONS } from './date-range-selector.constants';
import { DateRangeCalendarOutput } from './date-range-calendar/date-range-calendar.interface';
import { DateRange } from './date-range-selector.interface';

@Component({
  selector: 'app-date-range-selector',
  standalone: true,
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss'],
  imports: [CommonModule, OverlayModule, MatButtonModule, DateRangeCalendarComponent],
})
export class DateRangeSelectorComponent implements OnInit {
  @Output() dateRangeChanged = new EventEmitter<DateRange>();
  @Input() allowFutureDate = false;

  protected isOverlayOpened = false;
  protected maxDate: Moment | null = moment();
  protected readonly OVERLAY_POSITIONS = OVERLAY_POSITIONS;
  protected readonly MAIN_TIMEZONE = 'Europe/Berlin';

  protected selectedRange: DateRangeCalendarOutput = DateRangeCalendarComponent.DEFAULT_DATE_RANGE;

  ngOnInit(): void {
    this.dateRangeChanged.emit(this.selectedRange.dateRange);
    if (this.allowFutureDate) {
      this.maxDate = null;
    }
  }

  protected onCalenderChanged(range: DateRangeCalendarOutput): void {
    this.selectedRange = {
      ...range,
      dateRange: {
        startDate: this.formatToGaolTz(range.dateRange.startDate),
        endDate: this.formatToGaolTz(range.dateRange.endDate),
      },
    };
    this.isOverlayOpened = false;

    this.dateRangeChanged.emit({
      startDate: this.selectedRange.dateRange.startDate,
      endDate: this.selectedRange.dateRange.endDate,
    });
  }

  private formatToGaolTz(date: Moment | null): Moment {
    const localTimezone = moment.tz.guess();
    const dateStr = moment(date).tz(localTimezone).format('YYYY-MM-DD HH:mm');
    return moment.tz(dateStr, this.MAIN_TIMEZONE);
  }
}
